import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TITOLARE = {
  nome: "Leonardo Cinel",
  cf: "CNLLRD08C13L407Z",
  domicilio: "Venezia (VE), Italia",
  email: "contact@eternamotion.com",
};

const LAST_UPDATE = "28 febbraio 2026";

const IT = {
  title: "Privacy Policy",
  intro: `La presente informativa descrive come vengono trattati i dati personali degli utenti del sito eternamotion.com, in conformità al Regolamento (UE) 2016/679 (GDPR) e al D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.`,
  sections: [
    {
      h: "1. Titolare del trattamento",
      p: [
        `Il Titolare del trattamento è ${TITOLARE.nome}, C.F. ${TITOLARE.cf}, con domicilio in ${TITOLARE.domicilio}, che opera come prestatore d'opera occasionale ai sensi dell'art. 67 co. 1 lett. l) del TUIR (D.P.R. 917/1986).`,
        `Per esercitare i tuoi diritti o richiedere informazioni scrivi a: <a href="mailto:${TITOLARE.email}" style="color:#C4A462;text-decoration:underline">${TITOLARE.email}</a>`,
      ],
    },
    {
      h: "2. Dati personali raccolti",
      p: [
        `Raccogliamo esclusivamente i dati che tu stesso ci fornisci compilando i moduli presenti sul sito, oltre ad alcuni dati tecnici raccolti automaticamente.`,
        `<strong>Modulo Contatti</strong>: nome, indirizzo email, numero di telefono (opzionale), motivo della richiesta, testo del messaggio.`,
        `<strong>Iscrizione Newsletter</strong>: indirizzo email, lingua preferita (IT/EN), consenso a ricevere comunicazioni commerciali, flag "avvisami al lancio" (opzionale).`,
        `<strong>Modulo Proposte Private</strong>: nome, email, telefono (opzionale), testo del progetto.`,
        `<strong>Dati tecnici automatici</strong>: indirizzo IP, tipo di browser, sistema operativo, pagine visitate, data e ora dell'accesso, referrer. Raccolti tramite log server per finalità di sicurezza e statistiche aggregate.`,
      ],
    },
    {
      h: "3. Finalità del trattamento",
      p: [
        `<strong>a) Riscontro alle richieste</strong>: i dati inseriti nei moduli sono utilizzati esclusivamente per rispondere alle tue richieste di contatto, proposte private o informazioni sui servizi.`,
        `<strong>b) Invio newsletter</strong>: se hai prestato specifico consenso spuntando la casella dedicata, il tuo indirizzo email verrà utilizzato per inviarti comunicazioni relative a ETERNA Motion (nuove opere Limited Edition, inviti privati, lancio del sito, aggiornamenti dell'atelier).`,
        `<strong>c) Adempimenti di legge</strong>: conservazione dei dati per il tempo strettamente necessario a rispettare obblighi normativi o difendersi in giudizio.`,
        `<strong>d) Sicurezza del sito</strong>: i log tecnici sono utilizzati per prevenire abusi, individuare tentativi di intrusione e garantire la corretta erogazione del servizio.`,
      ],
    },
    {
      h: "4. Base giuridica",
      p: [
        `Il trattamento è fondato sulle seguenti basi giuridiche (art. 6 GDPR):`,
        `— <strong>Consenso</strong> (art. 6.1.a): per l'iscrizione alla newsletter, revocabile in qualsiasi momento;`,
        `— <strong>Esecuzione di misure precontrattuali</strong> (art. 6.1.b): per rispondere alle tue richieste tramite form contatti/proposte private;`,
        `— <strong>Legittimo interesse</strong> (art. 6.1.f): per il trattamento dei log tecnici a fini di sicurezza informatica;`,
        `— <strong>Obbligo di legge</strong> (art. 6.1.c): per conservazioni imposte da normativa fiscale o giudiziaria.`,
      ],
    },
    {
      h: "5. Destinatari e trasferimento dati",
      p: [
        `I tuoi dati NON vengono venduti, ceduti o comunicati a terzi per finalità di marketing. Possono essere trattati dai seguenti fornitori tecnici, in qualità di Responsabili del trattamento designati ai sensi dell'art. 28 GDPR:`,
        `— <strong>Resend, Inc.</strong> (USA) — invio email transazionali e newsletter. Trasferimento in USA basato su Clausole Contrattuali Standard UE. <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Privacy Policy Resend</a>`,
        `— <strong>Cloudflare, Inc.</strong> (USA) — CDN, sicurezza e infrastruttura DNS. Trasferimento in USA basato su Clausole Contrattuali Standard UE. <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Privacy Policy Cloudflare</a>`,
        `— <strong>Emergent Labs</strong> — hosting applicativo e database. Server in UE.`,
        `— <strong>Aruba S.p.A.</strong> (Italia) — servizi email inbox del dominio eternamotion.com.`,
      ],
    },
    {
      h: "6. Conservazione dei dati",
      p: [
        `<strong>Iscrizioni newsletter</strong>: conservate finché l'utente non revoca il consenso tramite il link di disiscrizione presente in ogni email.`,
        `<strong>Messaggi da form contatti/proposte</strong>: conservati per massimo 24 mesi dalla ricezione, salvo diversa necessità di conservazione per finalità di difesa in giudizio.`,
        `<strong>Log server tecnici</strong>: conservati per un massimo di 30 giorni.`,
      ],
    },
    {
      h: "7. Diritti dell'interessato",
      p: [
        `In qualsiasi momento puoi esercitare i seguenti diritti (artt. 15-22 GDPR):`,
        `— accedere ai tuoi dati e riceverne una copia;`,
        `— chiedere la rettifica di dati inesatti o incompleti;`,
        `— chiedere la cancellazione ("diritto all'oblio");`,
        `— chiedere la limitazione o opporti al trattamento;`,
        `— richiedere la portabilità in formato strutturato;`,
        `— revocare in qualsiasi momento il consenso prestato;`,
        `— proporre reclamo al <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Garante per la protezione dei dati personali</a>.`,
        `Per esercitare i diritti scrivi a <a href="mailto:${TITOLARE.email}" style="color:#C4A462;text-decoration:underline">${TITOLARE.email}</a>. Riceverai riscontro entro 30 giorni.`,
      ],
    },
    {
      h: "8. Sicurezza",
      p: [
        `Adottiamo misure tecniche e organizzative adeguate per proteggere i dati da perdita, alterazione, accessi non autorizzati o divulgazione: connessione HTTPS con certificato TLS aggiornato, hash bcrypt per credenziali admin, sanitizzazione input, backup periodici e log di accesso.`,
      ],
    },
    {
      h: "9. Minori",
      p: [
        `I servizi del sito non sono rivolti a minori di 16 anni. Non raccogliamo consapevolmente dati di minori. Se ritieni che ci siano stati trasmessi dati riguardanti un minore, contattaci per la loro rimozione.`,
      ],
    },
    {
      h: "10. Modifiche a questa informativa",
      p: [
        `La presente informativa può essere aggiornata periodicamente. Le versioni precedenti restano disponibili su richiesta. La data di ultimo aggiornamento è indicata in fondo alla pagina.`,
      ],
    },
  ],
  cookieLink: `Per informazioni sui cookie tecnici utilizzati, consulta la nostra <a href="/cookie" style="color:#C4A462;text-decoration:underline">Cookie Policy</a>.`,
};

const EN = {
  title: "Privacy Policy",
  intro: `This notice describes how personal data of users of the eternamotion.com website is processed, in accordance with Regulation (EU) 2016/679 (GDPR) and Italian Legislative Decree 196/2003 as amended.`,
  sections: [
    {
      h: "1. Data Controller",
      p: [
        `The Data Controller is ${TITOLARE.nome}, Italian Tax Code ${TITOLARE.cf}, resident in ${TITOLARE.domicilio}, operating as an occasional service provider pursuant to art. 67(1)(l) of the Italian Income Tax Code (Presidential Decree 917/1986).`,
        `To exercise your rights or request information write to: <a href="mailto:${TITOLARE.email}" style="color:#C4A462;text-decoration:underline">${TITOLARE.email}</a>`,
      ],
    },
    {
      h: "2. Personal data collected",
      p: [
        `We collect only the data you provide through website forms, plus certain technical data collected automatically.`,
        `<strong>Contact Form</strong>: name, email, phone (optional), reason for the request, message.`,
        `<strong>Newsletter Subscription</strong>: email address, preferred language (IT/EN), consent to receive commercial communications, optional "notify at launch" flag.`,
        `<strong>Private Proposals Form</strong>: name, email, phone (optional), project description.`,
        `<strong>Automatic technical data</strong>: IP address, browser type, operating system, pages visited, access date/time, referrer. Collected via server logs for security and aggregate statistics.`,
      ],
    },
    {
      h: "3. Purposes",
      p: [
        `<strong>a) Responding to requests</strong>: form data is used only to reply to your contact requests, private proposals or service enquiries.`,
        `<strong>b) Newsletter delivery</strong>: if you have given specific consent by ticking the dedicated box, your email will be used to send communications about ETERNA Motion (new Limited Edition works, private invitations, site launch, atelier updates).`,
        `<strong>c) Legal obligations</strong>: retention for the time strictly necessary to comply with legal or judicial requirements.`,
        `<strong>d) Site security</strong>: technical logs are used to prevent abuse, detect intrusion attempts and ensure service delivery.`,
      ],
    },
    {
      h: "4. Legal basis",
      p: [
        `Processing is based on the following GDPR legal bases (art. 6):`,
        `— <strong>Consent</strong> (art. 6.1.a): for newsletter subscription, revocable at any time;`,
        `— <strong>Pre-contractual measures</strong> (art. 6.1.b): to reply to contact/private proposal enquiries;`,
        `— <strong>Legitimate interest</strong> (art. 6.1.f): for technical logs and site security;`,
        `— <strong>Legal obligation</strong> (art. 6.1.c): for retention imposed by tax or judicial regulations.`,
      ],
    },
    {
      h: "5. Recipients and data transfers",
      p: [
        `Your data is NEVER sold, transferred or shared with third parties for marketing purposes. Data may be processed by the following technical providers as designated Data Processors under art. 28 GDPR:`,
        `— <strong>Resend, Inc.</strong> (USA) — transactional email and newsletter delivery. US transfer based on EU Standard Contractual Clauses. <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Resend Privacy Policy</a>`,
        `— <strong>Cloudflare, Inc.</strong> (USA) — CDN, security and DNS. US transfer based on EU Standard Contractual Clauses. <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Cloudflare Privacy Policy</a>`,
        `— <strong>Emergent Labs</strong> — application hosting and database. EU servers.`,
        `— <strong>Aruba S.p.A.</strong> (Italy) — email inbox services for the eternamotion.com domain.`,
      ],
    },
    {
      h: "6. Data retention",
      p: [
        `<strong>Newsletter subscriptions</strong>: retained until the user revokes consent via the unsubscribe link in every email.`,
        `<strong>Contact/private proposals</strong>: retained for a maximum of 24 months from receipt, unless further retention is required for defence in court.`,
        `<strong>Technical server logs</strong>: retained for a maximum of 30 days.`,
      ],
    },
    {
      h: "7. Your rights",
      p: [
        `You may exercise the following rights at any time (arts. 15-22 GDPR):`,
        `— access your data and receive a copy;`,
        `— request rectification of inaccurate or incomplete data;`,
        `— request erasure ("right to be forgotten");`,
        `— request restriction of, or object to, processing;`,
        `— request data portability in a structured format;`,
        `— withdraw consent at any time;`,
        `— lodge a complaint with the <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" style="color:#C4A462;text-decoration:underline">Italian Data Protection Authority</a>.`,
        `To exercise your rights write to <a href="mailto:${TITOLARE.email}" style="color:#C4A462;text-decoration:underline">${TITOLARE.email}</a>. We will reply within 30 days.`,
      ],
    },
    {
      h: "8. Security",
      p: [
        `We adopt appropriate technical and organisational measures to protect data from loss, alteration, unauthorised access or disclosure: HTTPS with up-to-date TLS certificate, bcrypt hashes for admin credentials, input sanitisation, periodic backups and access logs.`,
      ],
    },
    {
      h: "9. Minors",
      p: [
        `The website is not intended for children under 16. We do not knowingly collect data from minors. If you believe minor data has been submitted, contact us for removal.`,
      ],
    },
    {
      h: "10. Changes to this notice",
      p: [
        `This notice may be updated periodically. Previous versions remain available on request. The last update date is indicated at the bottom of the page.`,
      ],
    },
  ],
  cookieLink: `For information about technical cookies used, please see our <a href="/cookie" style="color:#C4A462;text-decoration:underline">Cookie Policy</a>.`,
};

export default function PrivacyPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("en") ? "en" : "it";
  const C = lang === "en" ? EN : IT;

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#FAF9F6]" style={{ color: "#1A1B1A" }}>
      <Helmet>
        <html lang={lang} />
        <title>{`${C.title} — ETERNA Motion`}</title>
        <meta name="description" content={C.intro.substring(0, 160)} />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://eternamotion.com/privacy" />
      </Helmet>

      <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12 max-w-3xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C4A462] mb-4" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>
            {lang === "en" ? "Legal" : "Note legali"}
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter mb-6" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}>
            {C.title}
          </h1>
          <div className="w-16 h-px bg-[#C4A462] mb-8" />
          <p className="text-base text-[#4A4A4A] leading-relaxed mb-12" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}>
            {C.intro}
          </p>

          {C.sections.map((s) => (
            <div key={s.h} className="mb-10">
              <h2 className="text-xl sm:text-2xl tracking-tight text-[#1A1B1A] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                {s.h}
              </h2>
              {s.p.map((para, i) => (
                <p
                  key={i}
                  className="text-sm text-[#4A4A4A] leading-relaxed mb-3"
                  style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
                  dangerouslySetInnerHTML={{ __html: para }}
                />
              ))}
            </div>
          ))}

          <p
            className="text-sm text-[#4A4A4A] leading-relaxed mt-8 pt-8 border-t border-[#D8D4CC]"
            style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
            dangerouslySetInnerHTML={{ __html: C.cookieLink }}
          />

          <p className="text-xs uppercase tracking-[0.2em] text-[#757575] mt-6" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>
            {lang === "en" ? "Last updated" : "Ultimo aggiornamento"}: {LAST_UPDATE}
          </p>

          <Link to="/" className="inline-block mt-12 text-[10px] uppercase tracking-[0.25em] text-[#C4A462] hover:text-[#1A1B1A] transition-colors" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }} data-testid="privacy-back-home">
            ← {lang === "en" ? "Back to home" : "Torna alla home"}
          </Link>
        </motion.div>
      </section>
    </div>
  );
}
